import { useEffect } from "react";
import { useAppStore } from "@/store";
import { resolveAccentHex, deriveAccentColors, accentInkVars } from "@njbsoft/store";

export function useAccentSync() {
  const accentColor = useAppStore((s) => s.accentColor);
  const resolvedTheme = useAppStore((s) => s.resolvedTheme);

  useEffect(() => {
    const hex = resolveAccentHex(accentColor);
    const colors = deriveAccentColors(hex, resolvedTheme);
    const ink = accentInkVars(hex);
    const el = document.documentElement;
    el.style.setProperty("--color-primary", colors.primary);
    el.style.setProperty("--color-primary-hover", colors.primaryHover);
    el.style.setProperty("--color-secondary", colors.secondary);
    el.style.setProperty("--color-primary-light", colors.primaryLight);
    // CSS cannot call a function, so the on-accent ink is derived here and
    // published for `--form-accent-text` and `--color-on-primary` to reference.
    // Every reference carries a literal fallback, which is what paints before
    // this effect first runs. The app shell reads the LIGHT property in both of
    // its modes: it paints the raw accent in light and dark alike, and only the
    // form document lightens the accent for dark, which is what the second
    // property answers for.
    el.style.setProperty("--color-accent-ink-light", ink.light);
    el.style.setProperty("--color-accent-ink-dark", ink.dark);
  }, [accentColor, resolvedTheme]);
}
